<template>
  <div>
     <!-- 头部 -->
        <div  :class="banquanType==3?'thehead-boxss' :'thehead-boxs'">
              <div class="thehead">
               <div class="img-box">
                  <!-- <img v-show="banquanType==3"  class="imge" src="../image/icon2.png"> -->
                   <img   class="imge" src="../image/tou2.png">
                 </div> 
                <div :class="current=='主页'?'thehead-box2s': 'thehead-box2'">
                      <span  style="font-size: 22px" :class="current=='主页'?'thehead-fengts': 'thehead-fengt'"  @click="dahui1(1)">大赛介绍</span>
                      <!-- <span style="font-size: 22px" :class="current=='活动'?'thehead-fengts': 'thehead-fengt'"  @click="dahui1(2)">特色活动</span> -->
                      <span style="font-size: 22px" :class="current=='活动资讯'?'thehead-fengts': 'thehead-fengt'"  @click="dahui1(3)">活动资讯</span>
                      <span style="font-size: 22px" :class="current=='参赛'?'thehead-fengts': 'thehead-fengt'"  @click="dahui1(4)">我要参赛</span>
                </div>
            </div>
        </div>
        <!-- 头部结束 -->
  </div>
</template>
<script>
export default {
  props:{
			 banquanType: {
				  type: Number,
				  default () {
					return 1
				  }
				},
        current:{
				type:String,
				default:'主页'
			}
		},
  name: 'headTail',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
    dahui1(i) {
       if (i==1) {
			  this.$router.push('/')
			  }
			  else if (i==2) {
			  	this.$router.push('/activity') 
			  }
			  else if (i==3) {
			  this.$router.push('/news') 
			  }
			  else if (i==4) {
			  this.$router.push('/participating') 
			  }
    }
  },
   watch:{
		     banquanType(val, oldVal){//普通的watch监听
		        　this.banquanType = val
		        　console.log('显示', this.banquanType)
				}
		     },
}
</script>
<style scoped>
/* 首页 */
.box{
  width: 1920px;
 
}
.thehead-boxs{
  width: 1920px;
  height: 96px;
  /* background: #A49979 ; */
   background: #F0F0F0;

}
.thehead-boxss{
  width: 1920px;
  height: 96px;
   background: #F0F0F0;
 /* background: rgba(0, 0, 0, 0.5); */
  /* background: #EEEEEE ; */
 
}
.thehead-box{
  width: 1920px;
 height: 120px;
  background: #FFFFFF;
 
  /* background: yellow; */
}
.thehead-box2{
  /* background: yellow; */
  width: 500px;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  /* padding-right: 335px; */
}
.thehead-box2s{
  /* background: yellow; */
  width: 500px;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  font-weight: 400;
/* color: #FFFFFF; */

  /* padding-right: 335px; */
}
.thehead{
  width: 100;
  margin: auto;
  /* background: yellow; */
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 142px;
  padding-right: 450px;
  
}
.img-box{
  width: 100;
 padding-right: 430px;
  /* background: red; */
  text-align: initial;
}
.imge{
  width: 134px;
  height: 77px;
}
.thehead-fengt{
  /* color: #FFFFFF; */
  font-size: 24px;
  font-weight: 400;
}

.thehead-fengt:hover{
   color: #EDC34E;
   cursor:pointer;
}
.thehead-fengts{
  /* color: #FFFFFF; */
  font-size: 30px;
  color: #EDC34E;
    font-weight: 400;
  
}

/* 首页结束 */
</style>


// WEBPACK FOOTER //
// src/components/headTail.vue